import { Button, Checkbox, Form, Input, Breadcrumb, Layout, Menu } from "antd";
import React, { useEffect } from "react";
import "antd/dist/antd.min.css";
import { useAppSelector, useAppDispatch } from "../../store/hooks";
import { logoutUser, setLoggedInUser } from "../../store/userSlice";
import GameClient from "../../GameClient";

const { Header, Content, Footer } = Layout;

const Login: React.FC = () => {
  const dispatch = useAppDispatch();
  const onLoginSuccess = async (values: any) => {
    const { username, password } = values;
    try {
      const user = await GameClient.Login(username, password);
      dispatch(setLoggedInUser({ id: user.id, username: user.username }));
    } catch (e) {
      alert(e);
    }
  };
  const onLoginFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  const logout = () => {
    try {
      GameClient.Logout();
      dispatch(logoutUser());
    } catch (e) {
      alert(e);
    }
  };

  const user = useAppSelector((game) => game.user.loggedInUser);
  if (user) {
    return (
      <Content
        style={{
          marginLeft: "auto",
          marginRight: "auto",
          padding: "50px 50px",
        }}
      >
        <Button onClick={() => logout()}>Logout</Button>
      </Content>
    );
  }

  return (
    <Content style={{ padding: "50px 50px" }}>
      <Form
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 2 }}
        initialValues={{ remember: true }}
        onFinish={onLoginSuccess}
        onFinishFailed={onLoginFailed}
        autoComplete="off"
      >
        <Form.Item
          label="Username"
          name="username"
          rules={[{ required: true, message: "Please input your username!" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Content>
  );
};

export default Login;
